let validation = {}
validation.accountRules = (val) => {
    const reg = /^[^\d]*$|^[^a-zA-Z]*$|[^\da-zA-Z]/;
    if (reg.test(val)) {
        return false;
    }
    return true;
}
validation.nickName = (val) => {
    return val.replace(/[\u0391-\uFFE5]/g, "aa").length;
}
export default validation;